import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onCreateCompany,
  onDeleteCompany,
  onGetCompany,
  onGetPagedAllCompanies,
  onGetPagedAllCompaniesForAdmin,
  onUpdateCompany,
  onUpdateCompanyForAdmin,
} from '../../../app/modules/company-and-job/components/companies/core/_requests'
import {
  onGetCompanyTypes,
  onGetConfirmationStatuses,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface CompanyState {
  allCompanies: any
  allCompaniesForAdmin: any
  company: any
  companyTypes: any
  confirmationStatuses: any
  isLoading: boolean
}
const initialState = {
  allCompanies: [],
  allCompaniesForAdmin: [],
  company: null,
  companyTypes: [],
  confirmationStatuses: [],
  isLoading: true,
} as CompanyState

export const fetchCompanyTypes = createAsyncThunk('company/fetchCompanyTypes', async () => {
  const data: any = await onGetCompanyTypes()
  return data.data.result.items
})

export const fetchCompanyConfirmationStatuses = createAsyncThunk(
  'company/fetchCompanyConfirmationStatuses',
  async () => {
    const data: any = await onGetConfirmationStatuses()
    return data.data.result.items
  }
)

export const fetchAllCompanies = createAsyncThunk(
  'company/fetchAllCompanies',
  async (param: any) => {
    const data: any = await onGetPagedAllCompanies(param)
    return data.data.result
  }
)

export const fetchAllCompaniesForAdmin = createAsyncThunk(
  'company/fetchAllCompaniesForAdmin',
  async (param: any) => {
    const data: any = await onGetPagedAllCompaniesForAdmin(param)
    return data.data.result
  }
)

export const fetchCompany = createAsyncThunk('company/fetchCompany', async (param: any) => {
  const data: any = await onGetCompany(param)
  return data.data.result
})

export const updateCompany = createAsyncThunk('company/updateCompany', async (param: any) => {
  const data: any = await onUpdateCompany(param)
  return data.data
})

export const updateCompanyForAdmin = createAsyncThunk(
  'company/updateCompanyForAdmin',
  async (param: any) => {
    const data: any = await onUpdateCompanyForAdmin(param)
    return data.data
  }
)

export const createCompany = createAsyncThunk('company/createCompany', async (param: any) => {
  const data: any = await onCreateCompany(param)
  return data.data
})

export const deleteCompany = createAsyncThunk('company/deleteCompany', async (param: any) => {
  const data: any = await onDeleteCompany(param)
  return data.data
})

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    clearAllCompanies: (state) => {
      state.allCompanies = []
    },
    clearCompany: (state) => {
      state.company = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllCompanies.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllCompanies.fulfilled, (state: any, action) => {
      state.allCompanies = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAllCompanies.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchCompany.fulfilled, (state: any, action) => {
      state.company = action.payload
    })
    builder.addCase(fetchAllCompaniesForAdmin.pending, (state: any) => {
      state.isLoading = true
      state.isLoading = false
    })
    builder.addCase(fetchAllCompaniesForAdmin.fulfilled, (state: any, action) => {
      state.allCompanies = action.payload
    })
    builder.addCase(fetchAllCompaniesForAdmin.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchCompanyTypes.fulfilled, (state: any, action) => {
      state.companyTypes = action.payload
    })
    builder.addCase(fetchCompanyConfirmationStatuses.fulfilled, (state: any, action) => {
      state.confirmationStatuses = action.payload
    })
  },
})

export const {clearAllCompanies, clearCompany, activateLoading} = companySlice.actions

export default companySlice.reducer
